export const formatWildcardId = (id: string) => `${id}-*`;
